import React, { useState } from "react"
import { StorageService } from "../../../services"
import StyledDiv from './styles'
import { images } from "../../../images"
import { Application } from "../../../config"

interface IProps {
  textTitle: string
  textContent: string,
  backgroundColor: string
}

const { isIframe } = Application

export const ReservationInstructions: React.FC<IProps> = ({
  textTitle,
  textContent,
  backgroundColor
}) => {

  const [ isExpanded, setIsExpanded] = useState(true)

  const iconExpandPressed = (): void => {
    const exp = !isExpanded
    setIsExpanded(exp)
    StorageService.setIsInstructionsExpanded(exp)
  }

  const expanded = isIframe ? true : isExpanded

  return (
    <StyledDiv style={ { backgroundColor: backgroundColor } }>
      <div className="title-container">
        <h4> { textTitle } </h4>
        { !isIframe &&
          <div className="icon-container" onClick={ () => iconExpandPressed() }>
            <img
              src={ images[expanded ? 'up' : 'down'] }
            />
          </div>
        }
      </div>
      {
        expanded &&
        <div>
          <div>
            { textContent }
          </div>
        </div>
      }
    </StyledDiv>
  )
}